/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Feature } from 'client-code/fe-fav-service';

import { PCSettings } from '../entities';
import { IParentalControlServiceRepository } from '../interfaces';
import { Log } from '../logging/Log';
import { TExtendedRatingLimits, TPCServiceParams, TServicesParams } from '../types';

export class ParentalControlServiceRepositoryImpl implements IParentalControlServiceRepository {
    private static TAG: string = 'ParentalControlServiceRepositoryImpl';

    private mParentalSettingsData: Feature | undefined;

    private mDefaultPCPin: string;

    private mRatingsInstructionsData: TExtendedRatingLimits;

    private mPCSetting: Map<string, string> = new Map();

    public constructor(params: TServicesParams & TPCServiceParams) {
        this.mParentalSettingsData = params.parentalSettingsData;
        this.mDefaultPCPin = params.defaultPCPin ?? '';
        this.mRatingsInstructionsData = params.ratingsInstructionsData;
    }

    /**
     * @inheritdoc
     */
    public fetchPCSetting(): Map<string, string> {
        try {
            // Getting parentalSettings from parentalSettingsData
            this.mParentalSettingsData?.attributes?.forEach(({ attributeName, attributeValue }) => {
                if (attributeName && attributeValue) {
                    this.mPCSetting.set(attributeName, attributeValue);
                }
            });

            this.mPCSetting.set(PCSettings.DEFAULT_PC_PIN, this.mDefaultPCPin);

            // Getting rating instructions from ratingsInstructionsData
            this.mPCSetting.set(
                PCSettings.RATINGS_INSTRUCTIONS,
                JSON.stringify(this.mRatingsInstructionsData),
            );
            return this.mPCSetting;
        } catch (error) {
            Log.e(ParentalControlServiceRepositoryImpl.TAG, 'fetchPCSetting', error);
            throw error;
        }
    }

    /**
     * @inheritdoc
     */
    public updatePCSetting(key: string, value: string): void {
        try {
            this.mPCSetting.set(key, value);
        } catch (error) {
            Log.e(ParentalControlServiceRepositoryImpl.TAG, 'updatePCSetting');
            throw error;
        }
    }
}
